import type React from "react";
import {
  ActionIcon,
  NumberInput,
  Popover,
  Select,
  Stack,
  Tooltip,
} from "@mantine/core";
import { IconSettings } from "@tabler/icons-react";

export interface IndexOption {
  value: string;
  label: string;
}

interface SearchConfigProps {
  indexOptions: IndexOption[];
  indexId: string;
  onIndexChange: (value: string) => void;
  topK: number;
  onTopKChange: (value: number) => void;
}

const SearchConfig: React.FC<SearchConfigProps> = ({
  indexOptions,
  indexId,
  onIndexChange,
  topK,
  onTopKChange,
}) => {
  return (
    <Popover position="bottom-end" withArrow shadow="md" width={300}>
      <Popover.Target>
        <Tooltip label="Search settings">
          <ActionIcon
            variant="default"
            size={42}
            radius="sm"
            aria-label="Search settings"
          >
            <IconSettings size={18} />
          </ActionIcon>
        </Tooltip>
      </Popover.Target>
      <Popover.Dropdown>
        <Stack gap="md">
          <Select
            label="Index"
            data={indexOptions}
            value={indexId}
            onChange={(value) => onIndexChange(value ?? indexId)}
            allowDeselect={false}
            comboboxProps={{ withinPortal: true }}
          />
          <NumberInput
            label="Results (top K)"
            value={topK}
            onChange={(value) =>
              onTopKChange(typeof value === "number" ? value : topK)
            }
            min={1}
            max={100}
            clampBehavior="strict"
          />
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
};

export default SearchConfig;
